// extracted by mini-css-extract-plugin
module.exports = {"contentContainer":"PostAuthUpsell_contentContainer__o5nWR","fadeIn":"PostAuthUpsell_fadeIn__fOKoj"};